import { Card, debounce, InputBase, Paper, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import * as React from 'react';
import { WithStyles, withStyles } from '@mui/styles';
import { useSelector } from 'react-redux';
import { getDetailsUWNotes, getSubmissionDetails } from 'application/redux/selectors';
import { useActions } from 'hooks/useActions';
import * as Actions from 'application/redux/actions';
import { useCallback, useEffect, useRef, useState } from 'react';
import { updateSubmissionUnderwritingNotes } from '../../../../../services/submission';
import styles from './Styles/styles';

interface Props {
    inForce?: boolean;
}

const UnderwriterNotes: React.FunctionComponent<Props & WithStyles<typeof styles>> = (props) => {
    const { inForce, classes } = props;

    const submission = useSelector(getSubmissionDetails);
    const notes = useSelector(getDetailsUWNotes);
    const { saveSubmissionUWNotes } = useActions(Actions);
    const [curNotes, setCurNotes] = useState<string>(notes);
    const [showSaving, setShowSaving] = useState<boolean>(false);
    const showSavingTimeout = useRef<any>(null);

    useEffect(() => {
        setCurNotes(notes);
    }, [notes]);

    const handleSaveNotes = async (newNotes: string) => {
        if (newNotes === notes) return; // we have already saved this
        setShowSaving(true);
        await updateSubmissionUnderwritingNotes(submission.id, newNotes);
        saveSubmissionUWNotes(newNotes);
        try {
            clearTimeout(showSavingTimeout.current);
            showSavingTimeout.current = null;
        } catch (e) {
            // do nothing if we can't clear, must not be active
        }
        showSavingTimeout.current = setTimeout(() => {
            setShowSaving(false);
            showSavingTimeout.current = null;
        }, 2000);
    };

    const debounced = useCallback(debounce(handleSaveNotes, 10000), [notes]);

    return (
        <Card>
            <Grid
                container
                className={classes.root}
                direction="column"
                justifyContent="center"
                alignItems="stretch"
                spacing={0}
            >
                <Grid style={{ marginTop: '0' }}>
                    <Typography variant="h4">Underwriting Notes</Typography>
                </Grid>
                <Grid className={classes.notesGridItem}>
                    <Paper className={classes.paperNotes}>
                        <InputBase
                            readOnly={inForce}
                            multiline
                            margin="none"
                            value={curNotes}
                            placeholder={'Underwriting review notes'}
                            classes={{ root: classes.notesTextField, input: classes.narrative }}
                            onChange={(event) => {
                                setCurNotes(event.target.value);
                                // TODO save notes to submission via API call
                                debounced(event.target.value);
                            }}
                            onBlur={(event) => {
                                handleSaveNotes(event.target.value);
                                debounced.clear();
                            }}
                        />
                        {showSaving && (
                            <Typography className={classes.saving} variant={'subtitle1'}>
                                saving...
                            </Typography>
                        )}
                    </Paper>
                </Grid>
            </Grid>
        </Card>
    );
};

export default withStyles(styles)(React.memo(UnderwriterNotes));
